"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _VidyardTermsOfServiceModal = _interopRequireDefault(require("FileManagerCore/components/VidyardTermsOfServiceModal"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _FileManagerImages = require("FileManagerImages");

var _Actions = require("FileManagerLib/actions/Actions");

var _hubLVideo = require("FileManagerCore/utils/hubLVideo");

var _Constants = require("FileManagerCore/Constants");

function getI18nKey(suffix) {
  return "FileManagerLib.vidyardPickerBanner." + suffix;
}

var PickerVidyardBanner =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(PickerVidyardBanner, _Component);

  function PickerVidyardBanner(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PickerVidyardBanner);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PickerVidyardBanner).call(this, props));
    _this.state = {
      isVidyardTermsOfServiceModalOpen: false
    };
    return _this;
  }

  (0, _createClass2.default)(PickerVidyardBanner, [{
    key: "openVidyardTosModal",
    value: function openVidyardTosModal() {
      this.setState({
        isVidyardTermsOfServiceModalOpen: true
      });
    }
  }, {
    key: "closeVidyardTosModal",
    value: function closeVidyardTosModal() {
      this.setState({
        isVidyardTermsOfServiceModalOpen: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          isFileManagerPortalDataUpdatePending = _this$props.isFileManagerPortalDataUpdatePending,
          updateVidyardTosStatus = _this$props.updateVidyardTosStatus,
          inferredUserRole = _this$props.inferredUserRole,
          currentVidyardTosStatus = _this$props.currentVidyardTosStatus,
          dispatchTrackInteraction = _this$props.dispatchTrackInteraction,
          hubLVideosCount = _this$props.hubLVideosCount;
      var isVidyardTermsOfServiceModalOpen = this.state.isVidyardTermsOfServiceModalOpen;
      return _react.default.createElement("div", {
        className: "text-center m-y-5"
      }, _react.default.createElement(_UIImage.default, {
        className: "m-y-10",
        width: 180,
        src: (0, _FileManagerImages.getImageUrl)('empty-dashboard'),
        responsive: false
      }), _react.default.createElement("h5", null, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('title')
      })), _react.default.createElement("p", null, currentVidyardTosStatus === _Constants.VidyardTosStatus.ACCEPTED && hubLVideosCount === 0 ? _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('message.noVideos')
      }) : _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('message.tosMessage')
      })), _react.default.createElement(_UIButton.default, {
        use: "primary",
        onClick: function onClick() {
          return _this2.openVidyardTosModal();
        }
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('enableVidyard')
      })), isVidyardTermsOfServiceModalOpen && _react.default.createElement(_VidyardTermsOfServiceModal.default, {
        inferredUserRole: inferredUserRole,
        updateVidyardTosStatus: updateVidyardTosStatus,
        isLoading: isFileManagerPortalDataUpdatePending,
        onClose: function onClose() {
          return _this2.closeVidyardTosModal();
        },
        trackInteraction: (0, _hubLVideo.wrapTrackHubLVideoInteraction)(dispatchTrackInteraction)
      }));
    }
  }]);
  return PickerVidyardBanner;
}(_react.Component);

PickerVidyardBanner.propTypes = {
  hubLVideosCount: _react.PropTypes.number.isRequired,
  currentVidyardTosStatus: _react.PropTypes.oneOf(Object.keys(_Constants.VidyardTosStatus)).isRequired,
  isFileManagerPortalDataUpdatePending: _react.PropTypes.bool.isRequired,
  updateVidyardTosStatus: _react.PropTypes.func.isRequired,
  inferredUserRole: _react.PropTypes.string.isRequired,
  dispatchTrackInteraction: _react.PropTypes.func.isRequired
};
var mapDispatchToProps = {
  dispatchTrackInteraction: _Actions.trackInteraction
};

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(PickerVidyardBanner);

exports.default = _default;
module.exports = exports.default;